import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionOutputRow } from "../types";

const ModuleVersionOutputsTableDescriptionCell = ({
  item: output,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionOutputRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={output.description} />
    </TableSimpleCell>
  );
};

export default ModuleVersionOutputsTableDescriptionCell;
